import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import Helmet from 'react-helmet';
import RpTable from 'rp-react-table';

import HeaderRow from './HeaderRow';
import columns from './columns';
import { addBetWithCur } from './utils';
import Switcher from '../common/Switcher';
import meta from './meta.json';
/**
 * PressChallenge page class
 * consists of Helmet, that contains meta information
 * and Table with data
 */
export default class PressChallenge extends PureComponent {
    constructor(props) {
        super(props);
        /**
         * create pages initial state
         * By default Year switcher button should be selected
         * @type {{isYearSelected: boolean}}
         */
        this.state = {
            isYearSelected: true
        };
        /**
         * Bind methods of this class
         */
        this.switchPeriod = this.switchPeriod.bind(this);
    }

    /**
     * set isYearSelected argument as current states value
     * @param isYearSelected
     */
    switchPeriod(isYearSelected) {
        this.setState({ isYearSelected });
    }

    render() {
        const { data, loading } = this.props;
        const { isYearSelected } = this.state;

        const monthCssClass = !isYearSelected ? 'tn-pressChallenge_month' : '';
        const tableData = addBetWithCur(data);

        return (
            <div className={`tn-pressChallenge ${monthCssClass}`}>
                <Helmet {...meta} />
                <div className="tn-pressChallenge__headerBlock">
                    <h2 className="tn-subHeader">Records for the current year</h2>
                    <Switcher
                        isYearSelected={isYearSelected}
                        switchPeriod={this.switchPeriod}
                        cssClass="hideFromMedium"
                    />
                </div>
                <RpTable
                    data={tableData}
                    columns={columns}
                    initialSortIdx={0}
                    className="ui-table_type1 pressChalllenge"
                    headerRow={HeaderRow}
                    sortable
                    noDataText="No press challenge records in the Racing Post database"
                    loading={loading}
                />
                <div className="tn-pressChallenge__note">
                    <h5 className="tn-pressChallenge__noteHeader">About Press Challenge</h5>
                    Competitors begin with a theoretical bank of £1,000, from which £1 is staked at
                    SP on races for which the Racing Post carries a full selection box (usually all
                    meetings except Bank Holidays). The tipster with the largest bank at the end
                    of the year wins £2,000; the runner-up £500.
                    The tipster with the best record for each individual month receives £100.
                </div>
            </div>
        );
    }
}
/**
 * Prop types validation
 * @type {{loading: *, data: *}}
 */
PressChallenge.propTypes = {
    loading: PropTypes.bool.isRequired,
    data: PropTypes.arrayOf(PropTypes.shape({
        turnOver: PropTypes.string,
        newspaperAndTipster: PropTypes.string,
        favsTipped: PropTypes.string,
        curSeq: PropTypes.string,
        napsBet: PropTypes.string,
        monthBet: PropTypes.string,
        winsTips: PropTypes.string,
        monthWinsTips: PropTypes.string
    })).isRequired
};



// WEBPACK FOOTER //
// ./src/js/pressChallenge/PressChallenge.js